import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgG2 = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 42 80",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		stroke: "#0D0E10",
		strokeWidth: 2,
		fill: "none",
		fillRule: "evenodd",
		children: [
			/* @__PURE__ */ _jsxs("g", {
				transform: "translate(13 19)",
				children: [/* @__PURE__ */ _jsx("rect", {
					x: -1,
					y: -1,
					width: 18,
					height: 18,
					rx: 1
				}), /* @__PURE__ */ _jsx("path", { d: "M6-1h4v4H6z" })]
			}),
			/* @__PURE__ */ _jsxs("g", {
				transform: "translate(4 37)",
				children: [/* @__PURE__ */ _jsx("rect", {
					x: -1,
					y: -1,
					width: 18,
					height: 18,
					rx: 1
				}), /* @__PURE__ */ _jsx("path", { d: "M6-1h4v4H6z" })]
			}),
			/* @__PURE__ */ _jsxs("g", {
				transform: "translate(22 37)",
				children: [/* @__PURE__ */ _jsx("rect", {
					x: -1,
					y: -1,
					width: 18,
					height: 18,
					rx: 1
				}), /* @__PURE__ */ _jsx("path", { d: "M6-1h4v4H6z" })]
			}),
			/* @__PURE__ */ _jsx("path", { d: "M1 54h40v4H1zM3 61h5v-3H3zM19 61h5v-3h-5zM34 61h5v-3h-5z" })
		]
	})
});
export default SvgG2;
